import React, { useContext } from 'react'
const ElavonResult = ({ formData, paymentData }) => {
    return (<></>)
}
export default ElavonResult